var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('el-carousel',{attrs:{"height":_vm.getHeight(),"arrow":"never","interval":5000}},_vm._l((_vm.bannerImg),function(item,index){return _c('el-carousel-item',{key:`banner${index}`},[_c('img',{staticStyle:{"height":"100%","width":"100%"},attrs:{"src":item}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }